var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"height1"},[_c('div',{staticClass:"iq-card-body"},[_vm._m(0),_c('el-divider')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pay-top"},[_c('p',{staticClass:"payItem"},[_vm._v("收款账户："),_c('span')]),_c('p',{staticClass:"payItem"},[_vm._v("收款日期："),_c('span')]),_c('p',{staticClass:"payNum"},[_vm._v("应付金额："),_c('span',[_vm._v("0.2")]),_vm._v(" 元")])])
}]

export { render, staticRenderFns }